// Translations come from the aem wrapper component
const state = {
  t: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    invalidEmail: 'Email must be valid',
    fieldRequired: 'This field is required',
    unknownError: 'An unknown error occurred',
    checkoutAsAGuest: 'Checkout as a Guest',
    createAnAccount: 'Create an Account',
    saveOrderHistory: 'Save your order history and checkout information.',
    continueAsGuest: 'Continue as Guest',
    alreadyCustomer: 'Already a Nu Skin customer?',
    signIn: 'Sign In',
    password: 'Password',
    agree2Terms: 'I agree to the terms of use and am aware of the privacy policy',
    contactMe: 'I would like to be contacted in the future',
    continueToCheckout: 'Continue to Checkout',
    accountExistsWithEmail: 'An account with this email address already exists',
    taxId: 'Government Tax ID',
    title: 'Nice to meet you!',
    subtitle: 'We need a couple details from you.'
  }
};

if (window.translations && Object.keys(window.translations).length > 0) {
  state.t = Object.assign(state.t, window.translations);
}

const getters = {

};

const mutations = {

};

const actions = {

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
